import cns from '../../../node_modules/classnames/index.js';
import { InputStates } from './common.js';

/**
 * Calcola le classi base ai componenti ai form fields
 * @param disabled stato disabilitato
 * @param readOnly stato sola lettura
 * @returns classe
 */
function getFormFieldClassNameBase(disabled, readOnly) {
    return cns('v2-form-field', {
        'v2-form-field--disabled': disabled,
        'v2-form-field--readonly': readOnly,
    });
}
/**
 * Calcola le classi comuni ai componenti ai form fields (base + state)
 * @param state stato di InputStates
 * @param disabled stato disabilitato
 * @param readOnly stato sola lettura
 * @returns classe
 */
// eslint-disable-next-line import/prefer-default-export
function getFormFieldClassName(state, disabled, readOnly) {
    return cns(getFormFieldClassNameBase(disabled, readOnly), {
        'v2-form-field--alarm': state === InputStates.alarm,
        'v2-form-field--warning': state === InputStates.warning,
        'v2-form-field--success': state === InputStates.success,
        'v2-form-field--loading': state === InputStates.loading,
    });
}

export { getFormFieldClassName };
